import { render, staticRenderFns } from "./-column-picker-manage.vue?vue&type=template&id=2d62f938&"
import script from "./-column-picker-manage.vue?vue&type=script&lang=js&"
export * from "./-column-picker-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports